<template>
  <div class="section-new-order">
    <form-customer :title="$gettext('Add Customer')"/>
  </div>
</template>

<script>
import FormCustomer from '@/components/FormCustomer.vue';

export default {
  name: 'AddCustomer',
  components: {
    FormCustomer,
  },
};
</script>
